var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationCreditCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 51h-4c-2.206 0-4-1.794-4-4V19c0-2.206 1.794-4 4-4h46c2.206 0 4 1.794 4 4v8h-2v-8c0-1.103-.897-2-2-2H12c-1.103 0-2 .897-2 2v28c0 1.103.897 2 2 2h4v2",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 31c-1.103 0-2 .897-2 2v28c0 1.103.897 2 2 2h46c1.103 0 2-.897 2-2V33c0-1.103-.897-2-2-2H22zm46 34H22c-2.206 0-4-1.794-4-4V33c0-2.206 1.794-4 4-4h46c2.206 0 4 1.794 4 4v28c0 2.206-1.794 4-4 4z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 55c-4.411 0-8-3.589-8-8s3.589-8 8-8c2.166 0 4.194.852 5.712 2.398l-1.428 1.401A5.958 5.958 0 0040 41c-3.309 0-6 2.691-6 6s2.691 6 6 6c1.626 0 3.147-.64 4.286-1.802l1.428 1.401A7.942 7.942 0 0140 55",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 41c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm0 14c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M9 21h52v-2H9zM9 31h7v-2H9zM12 39h4v-2h-4zM26 48h2v-2h-2zM62 48h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M46 25h10v-2H46zM40 25h4v-2h-4z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationCreditCards;